import { Component, Listen, Host, State, h } from '@stencil/core';

@Component({
  tag: 'spw-header-navigation',
  styleUrl: 'spw-header-navigation.scss',
  shadow: true,
})
export class SpwHeaderNavigation {
  @State() level: number = 0;
  @State() element: HTMLSpwHeaderNavigationItemElement | null = null;

  private redirectToHome(event: MouseEvent) {
    event.preventDefault();
    window.location.href = '/';
  }

  @Listen('spwHeaderNavigationNavigate', { capture: true })
  handleNavigation(event: CustomEvent<{ level: number; element: HTMLSpwHeaderNavigationItemElement }>) {
    event.stopPropagation();
    this.element = event.detail.element;
    this.level = event.detail.level;

    setTimeout(() => {
      this.updateNavigationItems();
    }, 0);
  }

  private updateNavigationItems() {
    const allItems = this.getAllNavigationItems();

    allItems.forEach((item, index) => {
      item.setAttribute('data-id', `${index + 1}`);
      item.setAttribute('data-level-visible', `${this.level}`);
    });
  }

  private getAllNavigationItems(): HTMLElement[] {
    const allItems: HTMLElement[] = [];
    const navItems = document.querySelectorAll('spw-header-navigation-item');

    navItems.forEach(item => {
      allItems.push(item);
      const shadowRoot = item.shadowRoot;
      if (shadowRoot) {
        const subItems = shadowRoot.querySelectorAll('spw-header-navigation-item');
        subItems.forEach(subItem => allItems.push(subItem as HTMLElement));
      }
    });

    return allItems;
  }

  render() {
    return (
      <Host>
        <nav class="spw-header-navigation">
          <ul class="spw-header-navigation__list spw-ds-container spw-tw-mx-auto">
            <li class="spw-header-navigation__list-back">
              <a href="#" onClick={event => this.redirectToHome(event)}>
                <spw-icon icon="fa-chevron-left"></spw-icon> <span>Page d'accueil</span>
              </a>
            </li>
            <slot></slot>
          </ul>
        </nav>
      </Host>
    );
  }
}
